import { ClientProvider } from './provider';
import { FbProvider } from './fb';
import { ProfileProvider } from './profile';
import { OffersProvider } from './offers';
import { ApiProvider } from './api';
import { MplProvider } from './mpl';
import { MTSProvider } from './mts';
import routes from '../../constants/routes.internal.json';
import { VitrinsProvider } from './vitrins';
import axios from 'axios';
import { TRACE_ID_HEADER } from '../../constants';
import { ArrangeProvider } from './arrange';

axios.interceptors.request.use((config) => {
    config.headers[TRACE_ID_HEADER] = Date.now().toString(36) + Math.ceil(Math.random() * 10e16).toString(36);
    return config;
});

export const provider = new ClientProvider(routes.provider);
export const fb = new FbProvider(routes.provider);
export const profile = new ProfileProvider(routes.provider);
export const offers = new OffersProvider(routes.provider);
export const api = new ApiProvider(routes.provider);
export const mpl = new MplProvider(routes.provider);
export const mts = new MTSProvider(routes.provider);
export const vitrins = new VitrinsProvider(routes.provider);
export const arrange = new ArrangeProvider(routes.provider);
